<div class="header-bar">
  <div class="header-left">
    <button mat-button
    *ngIf="!isNewUser&&!isSelf"
      color="warn"
      (click)="onDeleteClick()"
    >
      Delete
    </button>
  </div>
  <div class="header-center">{{ isNewUser ? "Create User" : "Edit User" }}</div>
  <div class="header-right">
    

    <button *ngIf="canActivate" 
      mat-button
      color="blueBayoux"
      [disabled]="activateDisabled"
      (click)="activate()">
      Send Activation Email
    </button>

    <button
      *ngIf="!isNewUser"
      mat-button
      color="lightGreen"
      [disabled]="saveDisabled"
      (click)="saveUser()"
    >
      Save User
    </button>

    <button
      *ngIf="isNewUser"
      mat-button
      color="lightGreen"
      [disabled]="saveDisabled"
      (click)="createUser()"
    >
      Create User
    </button>

  </div>
</div>

<div class="preferences">
  <div class="containers">
    <div class="container preferences-container">
      <div class="container-header no-bottom-border">
        <div class="text">Profile</div>
      </div>
      <div class="container-content">
        <form class="user-preferences-form" [formGroup]="userPreferencesForm">
          <div class="container-row">
            <lhpe-input
              controlName="firstName"
              placeholder="First Name"
              [formGroup]="userPreferencesForm"
              [required]="true"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-input
              controlName="lastName"
              placeholder="Last Name"
              [formGroup]="userPreferencesForm"
              [required]="true"
            >
            </lhpe-input>
          </div>
          <div class="container-row">
            <lhpe-input
              controlName="company"
              placeholder="Company"
              [formGroup]="userPreferencesForm"
            >
            </lhpe-input>
          </div>
          <div class="container-row">
            <lhpe-input
              controlName="email"
              placeholder="Email"
              [formGroup]="userPreferencesForm"
              type="email"
              [required]="true"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-select
              controlName="timeZone"
              placeholder="Time Zone"
              [formGroup]="userPreferencesForm"
              [required]="true"
              [options]="timeZoneOptions"
            >
            </lhpe-select>
          </div>

          <div *ngIf="isNewUser && !isSelf && showBasicRoleSelect" class="container-row">
            <lhpe-select
              controlName="basicRole"
              placeholder="Role"
              [formGroup]="userPreferencesForm"
              [required]="true"
              [options]="basicRoles"
              [optionIsSelf]="true"
              displayValue="name"
            >
            </lhpe-select>
          </div>

          <div
            *ngIf="!isSelf && currentUser?.super"
            class="container-row"
          >
            <div class="user-access">
              <div class="heading">Access</div>
              <div class="field">
                <div class="label">Super User</div>

                <mat-slide-toggle
                  #superSlideToggle
                  color="lightGreen"
                  formControlName="super"
                >
                  {{
                    userPreferencesForm.controls.super.value
                      ? "Enabled"
                      : "Disabled"
                  }}
                </mat-slide-toggle>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>

    <div
      *ngIf="!isNewUser && showAccountAccess"
      class="container accounts-container"
    >
      <div class="container-header no-bottom-border">
        <div class="text">Account Access</div>
      </div>
      <div class="container-content">
        <mat-accordion class="account-accordian">
          <mat-expansion-panel
            [id]="account.accountRelatedDTO.id"
            *ngFor="let account of availableAccounts"
            [ngClass]="{ disabled: !account.hasAccountUser }"
            [disabled]="!account.hasAccountUser"
            [(expanded)]="account.expanded"
            (opened)="initAccountUserForm(account)"
            hideToggle
          >
            <mat-expansion-panel-header
              [ngClass]="{ 'prevent-open': openedAccount }"
            >
              <mat-panel-title> {{ account.name }}</mat-panel-title>
              <button
                [disabled]="!!openedAccount"
                *ngIf="!account.hasAccountUser"
                mat-button
                class="add-btn"
                (click)="createAccountUser(account)"
              >
                <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
              </button>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <form
                *ngIf="openedAccount"
                class="account-user"
                [formGroup]="accountUserForm"
              >
                <div class="row">
                  <div class="role">
                    <lhpe-select
                      controlName="role"
                      placeholder="Role"
                      [formGroup]="accountUserForm"
                      [required]="true"
                      [options]="account.availableRoles"
                      optionValue="id"
                    >
                    </lhpe-select>
                  </div>
                  <div class="groups">
                    <div class="input-box">
                      <mat-form-field class="select-form">
                        <mat-label *ngIf="account.availableGroups.length"
                          >Groups</mat-label
                        >
                        <mat-label *ngIf="!account.availableGroups?.length"
                          >No Groups To Select</mat-label
                        >
                        <mat-select formControlName="groups" multiple>
                          <mat-option
                            class="mat-lightGreen"
                            *ngFor="let group of account.availableGroups"
                            [value]="group.id"
                            >{{ group.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
  
                    <div>
                      <lhpe-option-snack-group class="groups">
                        <lhpe-option-snack
                          *ngFor="let selectedGroup of selectedGroupsObjArr"
                          [option]="selectedGroup"
                          name="{{ selectedGroup.name }}"
                          (optionRemoved)="removeGroup($event)"
                          [disabled]="accountUserChangesDisabled"
                        >
                        </lhpe-option-snack>
                      </lhpe-option-snack-group>
                    </div>
                  </div>
                  <div class="facilities">
                    <div
                      *ngIf="account.availableFacilities.length > 1"
                      class="facilities-restriction-toggle"
                    >
                      <div class="label">Restrict Facilities</div>
  
                      <mat-slide-toggle
                        color="lightGreen"
                        formControlName="showFacilitiesRestriction"
                      >
                        {{
                          accountUserForm.controls.showFacilitiesRestriction.value
                            ? "Enabled"
                            : "Disabled"
                        }}
                      </mat-slide-toggle>
                    </div>
                    <div
                      *ngIf="
                        accountUserForm.controls.showFacilitiesRestriction.value
                      "
                      class="facilities-list"
                    >
                      <div *ngFor="let facility of account.availableFacilities">
                        <mat-checkbox
                          [checked]="!!selectedFacilities?.includes(facility.id)"
                          [disabled]="accountUserChangesDisabled"
                          color="lightGreen"
                          (change)="onFacilityToggled(facility)"
                          >{{ facility.name }}</mat-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="internalMail">
                    <div class="label">Send Nurture Emails</div>
                    <mat-slide-toggle
                      #nurtureSlideToggle
                      color="lightGreen"
                      [checked]="sendInternalEmails"
                      (click)="onInternalEmailClicked()"
                    >
                    </mat-slide-toggle>
                  </div>
                </div>
              </form>
              <div class="buttons">
                <button
                  class="btn"
                  color="fiord"
                  mat-button
                  (click)="closeAccountUser()"
                >
                  Close
                </button>
                <button
                  *ngIf="!accountUserChangesDisabled"
                  class="btn"
                  color="lightGreen"
                  mat-button
                  [disabled]="accountUserForm.invalid"
                  (click)="saveAccountUser(openedAccount!)"
                >
                  Save
                </button>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <div class="container billing-container" *ngIf="showBilling">
      <div class="container-header no-bottom-border">
        <div class="text">Manage Billing</div>
      </div>
      <div class="container-content">

        <div *ngFor="let cust of currentAccount.accountRelatedDTO.stripeCustomers" class="billing">
          <a [routerLink]="" (click)="goToBilling(cust.stripe_id)">{{cust.stripe_name}}</a>
        </div>

      </div>
    </div>

  </div>
</div>
